module.exports = __webpack_public_path__ + "img/certificate.152b61f8.png";